import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
export var features = {
  name: "yd8sa2",
  styles: "display:flex;flex-direction:column;gap:16px;"
};
export var steppers = {
  name: "j7qwjs",
  styles: "display:flex;flex-direction:column;"
};
export var propertyType = {
  name: "1821gv5",
  styles: "display:flex;flex-direction:column;gap:8px;"
};
export var propertyTypeList = /*#__PURE__*/css("display:grid;grid-template-columns:1fr 1fr;", media('>=tablet'), "{display:flex;flex-direction:row;}gap:8px;");